import React from 'react';

import { Spin } from 'antd';

import Sidebar from '../../screen/distributor/view/component/Sidebar/Sidebar';
import Navbar from '../../screen/distributor/view/navbar/navbar';
import StickNavBar from '../../screen/distributor/view/navbar/stickNavBar';

const Loader = () => {
  return (
    <div style={{ display: 'flex', flexDirection: 'row', overflow: 'hidden' }}>
      <Sidebar />
      <div className="container modifiedContainer">
        <Navbar />
        <div className="contentContainer">
          <Spin spinning={true}>
            <div style={{ maxWidth: '860px', height: '90vh' }} />
          </Spin>
        </div>
        <StickNavBar />
      </div>
    </div>
  );
};

export default Loader;
